export const safeFocus = (focusable?: { focus: () => void } | null) => {
  if (focusable) {
    setTimeout(() => focusable.focus(), 10);
  }
};
